import { Button } from 'components';
import QuickReplyChips from 'components/Chat/QuickReplyChips';
import {
  YARIKANO_CHAT_AUTO_QUESTION_ID,
  YARIKANO_CHAT_CTA_LABEL,
} from '../../constants';
import {
  EYarikanoCtaPlacement,
  EYarikanoQuestionId,
  TQuickReplyItem,
} from 'types';

type Props = {
  remainingChips: TQuickReplyItem[];
  showFooterCta: boolean;
  isResponding: boolean;
  footerQuestionId: EYarikanoQuestionId;
  onChipSelect: (chip: TQuickReplyItem) => void;
  onCtaClick: (
    questionId: EYarikanoQuestionId,
    placement: EYarikanoCtaPlacement,
  ) => void;
};

const YarikanoChatFooter = ({
  remainingChips,
  showFooterCta,
  isResponding,
  footerQuestionId,
  onChipSelect,
  onCtaClick,
}: Props) => {
  if (remainingChips.length > 0) {
    return (
      <div className="pb-4 border-t border-neutral-50">
        <QuickReplyChips
          items={remainingChips}
          disabled={isResponding}
          onSelect={onChipSelect}
        />
      </div>
    );
  }

  if (!showFooterCta) return null;

  return (
    <div className="px-4 py-4 border-t border-neutral-50" data-testid="yarikano-chat-footer-cta">
      <Button
        bold
        onClick={() =>
          onCtaClick(
            footerQuestionId ?? YARIKANO_CHAT_AUTO_QUESTION_ID,
            EYarikanoCtaPlacement.FOOTER,
          )
        }
        textSize="text-sm"
        rounded="rounded-full"
        iconRight="arrowRight"
        iconColor="white"
        block
      >
        {YARIKANO_CHAT_CTA_LABEL}
      </Button>
    </div>
  );
};

export default YarikanoChatFooter;
